import { HttpClient } from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { tap } from 'rxjs/operators';
import { date } from './date.service';
import { AuthService } from './auth.service';
import { LocalizationService } from './localization.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
import * as i3 from "./localization.service";
var NotificationLogService = /** @class */ (function () {
    function NotificationLogService(http, authService, baseUrl, localizationService) {
        this.http = http;
        this.authService = authService;
        this.baseUrl = baseUrl;
        this.localizationService = localizationService;
        this.apiUrl = this.baseUrl + "api/user/notifications";
    }
    NotificationLogService.prototype.getNotificationLog = function (id) {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getNotificationLogCall(id, subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) {
                return _this.getNotificationLogCall(id, obs);
            });
        });
    };
    NotificationLogService.prototype.getNotificationLogCall = function (id, subscriber) {
        return this.http
            .get(this.apiUrl + "/log/" + id)
            .subscribe(function (nots) { return subscriber.next(nots); }, function (error) { return subscriber.error(error); });
    };
    NotificationLogService.prototype.getNotificationLogs = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getNotificationLogsCall(subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) {
                return _this.getNotificationLogsCall(obs);
            });
        });
    };
    NotificationLogService.prototype.getNotificationLogsCall = function (subscriber) {
        var _this = this;
        this.http
            .get(this.apiUrl + "/logs")
            .pipe(tap(function (n) { return date(n, 'dateRead', 'createdDate'); }), tap(function (n) { return n.sort(_this.sortDescending); }))
            .subscribe(function (NotificationLogs) { return subscriber.next(NotificationLogs); }, function (error) { return subscriber.error(error); });
    };
    NotificationLogService.prototype.sortDescending = function (a, b) {
        return a.createdDate.getTime() > b.createdDate.getTime() ? -1 : 1;
    };
    NotificationLogService.prototype.markRead = function (nl) {
        return this.http.put(this.apiUrl + "/markRead", nl);
    };
    NotificationLogService.prototype.getUnreadCount = function () {
        return this.http.get(this.apiUrl + "/unreadCount");
    };
    NotificationLogService.ngInjectableDef = i0.defineInjectable({ factory: function NotificationLogService_Factory() { return new NotificationLogService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService), i0.inject("BASE_URL"), i0.inject(i3.LocalizationService)); }, token: NotificationLogService, providedIn: "root" });
    return NotificationLogService;
}());
export { NotificationLogService };
